<template>
  <div class="home">
    <div class="q_body">
      <div class="question" v-for="(li, index) in lists" :key="index" @mousedown="toItem(index)">
        <div class="title">
          <div class="left">
            <img :src="'/tutorial/static/img/icon' + (index > 0 ? (index + 2) : index) + '.png'" class="btn_question" />
            <p>{{ li }}</p>
          </div>
          <img src="/tutorial/static/img/btn_open.png" class="btn_icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  data () {
    return {
      lists: []
    }
  },
  methods: {
    toItem (index) {
      this.$router.push({ name: 'item', params: { item: (index > 0 ? (index + 3) : (index + 1)) } })
    }
  },
  created () {
    this.lists = [
      this.$t('faq.p2'),
      // this.$t('faq.p17'),
      // this.$t('faq.p58'),
      this.$t('faq.p71'),
      this.$t('faq.p88'),
      this.$t('faq.p107'),
      this.$t('faq.p154'),
      this.$t('faq.p176')
    ]
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  width: 100%;
  .q_body {
    padding-bottom: 0.5rem;
  }
  .question {
    position: relative;
    width: 100%;
    margin-top: 0.133rem;
    cursor: pointer;
  }
  .title {
    position: relative;
    width: 100%;
    min-height: 1.333rem;
    padding: 0.1rem 0px;
    border-top: 1px solid rgba(189, 189, 189, 0.2);
    border-bottom: 1px solid rgba(189, 189, 189, 0.2);
    border-width: thin;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    -webkit-tap-highlight-color: transparent;
  }
  .title .left {
    display: flex;
    align-items: center;
  }
  .left .btn_question {
    width: 80px;
    // margin: 0px 0.147rem 0px 0.347rem;
  }
  .left p {
    display: inline-block;
    font-size: 0.4rem;
    color: #242426;
  }
  .title .btn_icon {
    width: 18px;
    margin-right: 0.467rem;
    margin-left: 8px;
    transition: all 0.5s ease;
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  .content {
    position: relative;
    padding: 0.25rem 0.8rem;
    overflow: hidden;
    height: auto;
  }
  .content p {
    color: #888888;
    font-size: 0.347rem;
    line-height: 0.5rem;
  }
}
</style>
